import { useRef, useState } from 'react'
import cn from 'classnames'

import { ContentSteps } from 'src/lib/useStepFlow'
import Ring from 'src/icons/ring.webp'
import Light1 from 'src/icons/light-1.webp'
import Light2 from 'src/icons/light-2.webp'
import Diamond from 'src/icons/diamond.webp'
import { TLang } from 'src/constants/langs'
import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'

import { texts } from './text-first-step'

import { imageDataMap, textBtn } from './mock'

import styles from './styles.module.scss'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

export const FirstStep = ({ onNext, step, lang }: TProps) => {
    const { header } = useLocalizedText(lang, texts)
    const [rotated, setRotated] = useState(false)
    const [lightsOn, setLightsOn] = useState(false)
    const [goodBye, setGoodBye] = useState(false)

    const textBtnByLang =
        lang === 'ro' || lang === 'el' || lang === 'sl' ? lang : 'en'

    const getBtnTextByLang = () => {
        const foundText = textBtn.find((item) => item.lang === lang)

        return foundText ? foundText.text : ''
    }

    function getImageWheelDataByLang(lang: TLang) {
        return imageDataMap[lang] || imageDataMap['en']
    }

    const btnRef = useRef<HTMLImageElement>(null)

    const handleClick = () => {
        if (rotated) return

        setRotated(true)

        const btn = btnRef.current
        if (btn) {
            const style = window.getComputedStyle(btn)
            const matrix = new DOMMatrixReadOnly(style.transform)
            const currentScale = matrix.a

            btn.style.animation = 'none'
            btn.style.transform = `translate(-50%, -50%) scale(${currentScale})`

            requestAnimationFrame(() => {
                btn.style.transition = 'transform 0.5s ease-in-out'
                btn.style.transform = 'translate(-50%, -50%) scale(1)'
            })
        }
        setTimeout(() => {
            setLightsOn(true)
            setTimeout(() => {
                setGoodBye(true)
                setTimeout(() => {
                    onNext(step)
                }, 300)
            }, 2000)
        }, 2000)
    }

    return (
        <div className={styles.root}>
            <div className={styles.text_wrapper}>{header}</div>
            <div
                className={cn(styles.wheel_wrapper, {
                    [styles.good_bye]: goodBye,
                })}
            >
                <img src={Ring} alt="Ring" className={styles.ring} />
                <img
                    src={getImageWheelDataByLang(lang)}
                    alt="WheelData"
                    className={cn(styles.wheel_data, styles.calm_state, {
                        [styles.rotate]: rotated,
                    })}
                />
                <img
                    src={Light1}
                    alt="Light1"
                    className={cn(styles.lights, styles.lights_1, {
                        [styles.flash]: lightsOn,
                    })}
                />
                <img
                    src={Light2}
                    alt="Light2"
                    className={cn(styles.lights, styles.lights_2, {
                        [styles.flash]: lightsOn,
                    })}
                />
                <div
                    ref={btnRef}
                    className={cn(styles.wrapper_btn, {
                        [styles.btn_pulse]: !rotated,
                    })}
                    onClick={handleClick}
                >
                    <span
                        className={cn(
                            styles.text_btn,
                            styles[`text_btn__${textBtnByLang}`],
                            {
                                [styles.text_btn_rotated]: rotated,
                            }
                        )}
                    >
                        {getBtnTextByLang()}
                    </span>
                </div>

                <img
                    src={Diamond}
                    alt="Diamond"
                    className={cn(styles.diamond, {
                        [styles.jumping]: lightsOn,
                    })}
                />
            </div>
        </div>
    )
}
